(function () {
    const zoneLatLong = {};
    // zoneid,statecode,lat,long,zoom

    zoneLatLong.zone401 = ['AK', 62, -154.01, 4, 'Alaska'];
    zoneLatLong.zone311 = ['AL', 32.61, -86.7, 7, 'Alabama'];
    zoneLatLong.zone324 = ['AR', 34.75, -92.17, 7, 'Arkansas'];
    zoneLatLong.zone421 = ['AZ', 34.16, -111.93, 6, 'Arizona'];
    zoneLatLong.zone402 = ['CA (North)', 39.84, -121.62, 5, 'California'];
    zoneLatLong.zone411 = ['CA (South)', 35.38, -118.45, 5, 'California'];
    zoneLatLong.zoneCA = ['CA', 37.28, -119.25, 5, 'California'];
    zoneLatLong.zone422 = ['CO', 39, -105.56, 7, 'Colorado'];
    zoneLatLong.zone101 = ['CT', 41.52, -72.76, 8, 'Connecticut'];
    zoneLatLong.zone114 = ['DC', 38.93, -77, 10, 'Washington D.C.'];
    zoneLatLong.zone111 = ['DE', 39.14, -75.41, 8, 'Delaware'];
    zoneLatLong.zone312 = ['FL', 28.07, -83.83, 6, 'Florida'];
    zoneLatLong.zone313 = ['GA', 32.68, -83.22, 7, 'Georgia'];
    zoneLatLong.zone413 = ['HI', 20.21, -157.55, 7, 'Hawaii'];
    zoneLatLong.zone221 = ['IA', 41.95, -93.34, 7, 'Iowa'];
    zoneLatLong.zone241 = ['ID', 45.5, -114.14, 6, 'Idaho'];
    zoneLatLong.zone201 = ['Chicago IL', 41.82, -87.85, 8, 'Illinois'];
    zoneLatLong.zone202 = ['IL State', 39.77, -89.49, 6, 'Illinois'];
    zoneLatLong.zoneIL = ['IL', 39.77, -89.49, 6, 'Illinois'];
    zoneLatLong.zone203 = ['IN', 39.76, -86.43, 7, 'Indiana'];
    zoneLatLong.zone222 = ['KS', 38.5, -98.32, 7, 'Kansas'];
    zoneLatLong.zone211 = ['KY', 37.8, -85.75, 7, 'Kentucky'];
    zoneLatLong.zone322 = ['LA', 31.01, -91.6, 7, 'Louisiana'];
    zoneLatLong.zone121 = ['MA', 42.2, -71.71, 8, 'Massachuesetts'];
    zoneLatLong.zone112 = ['MD', 38.8, -77.29, 7, 'Maryland'];
    zoneLatLong.zone122 = ['ME', 45.26, -69.02, 7, 'Maine'];
    zoneLatLong.zone212 = ['MI', 44.99, -86.27, 6, 'Michigan'];
    zoneLatLong.zone242 = ['MN', 46.42, -93.39, 7, 'Minnesota'];
    zoneLatLong.zone223 = ['MO', 38.3, -92.46, 7, 'Missouri'];
    zoneLatLong.zone314 = ['MS', 32.6, -89.85, 7, 'Mississippi'];
    zoneLatLong.zone243 = ['MT', 46.72, -110.04, 6, 'Montana'];
    zoneLatLong.zone301 = ['NC', 35.23, -80.02, 7, 'North Carolina'];
    zoneLatLong.zone244 = ['ND', 47.47, -100.3, 7, 'North Dakota'];
    zoneLatLong.zone224 = ['NE', 41.5, -99.7, 7, 'Nebraska'];
    zoneLatLong.zone123 = ['NH', 44, -71.64, 7, 'New Hampshire'];
    zoneLatLong.zone102 = ['NJ', 40.15, -74.73, 8, 'New Jersey'];
    zoneLatLong.zone423 = ['NM', 34.16, -106.02, 6, 'New Mexico'];
    zoneLatLong.zone412 = ['NV', 38.52, -117.02, 6, 'Nevada'];
    zoneLatLong.zone103 = ['NY City', 40.7142, -74.01, 9, 'New York'];
    zoneLatLong.zone104 = ['NY State', 42.96, -75.72, 6, 'New York'];
    zoneLatLong.zoneNY = ['NY', 43.00, -76.51, 6, 'New York'];
    zoneLatLong.zone213 = ['OH', 40.17, -82.66, 7, 'Ohio'];
    zoneLatLong.zone323 = ['OK', 35.34, -98.71, 7, 'Oklahoma'];
    zoneLatLong.zone403 = ['OR', 44.09, -120.52, 7, 'Oregon'];
    zoneLatLong.zone113 = ['PA', 40.99, -77.61, 7, 'Pennsylvania'];
    zoneLatLong.zone124 = ['RI', 41.67, -71.46, 9, 'Rhode Island'];
    zoneLatLong.zone303 = ['SC', 33.59, -80.95, 7, 'South Carolina'];
    zoneLatLong.zone245 = ['SD', 44.24, -100.27, 7, 'South Dakota'];
    zoneLatLong.zone302 = ['TN', 35.82, -85.99, 7, 'Tennesee'];
    zoneLatLong.zone321 = ['TX', 31.17, -100.08, 6, 'Texas'];
    zoneLatLong.zone424 = ['UT', 39.48, -111.55, 6, 'Utah'];
    zoneLatLong.zone304 = ['VA', 37.97, -79.77, 7, 'Virginia'];
    zoneLatLong.zone125 = ['VT', 43.87, -72.46, 8, 'Vermont'];
    zoneLatLong.zone404 = ['WA', 47.33, -120.86, 7, 'Washington'];
    zoneLatLong.zone204 = ['WI', 44.7, -90.12, 7, 'Wisconsin'];
    zoneLatLong.zone214 = ['WV', 38.93, -80.19, 7, 'West Virginia'];
    zoneLatLong.zone246 = ['WY', 42.99, -107.55, 7, 'Wyoming'];
    zoneLatLong.zone0 = ['US', 36.69, -90.59, 4, 'National'];

    // Only used in geocode.js. We should be able to make it a module when that's migrated
    window.stateLatLong = [];

    for (const index in zoneLatLong) {
        window.stateLatLong[zoneLatLong[index][0]] = [index, zoneLatLong[index][1], zoneLatLong[index][2], zoneLatLong[index][3], zoneLatLong[index][4]];
    }
})();
